import(/* webpackMode: "eager", webpackExports: ["RSVPWrapperClient"] */ "/vercel/path0/src/app/beta/events/[eventSlug]/_components/rsvp_components/RSVPWrapperClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PermissionsContextProvider","EventContextProviderV2","EventRSVPWrapperProvider"] */ "/vercel/path0/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SmallRiverLoading"] */ "/vercel/path0/src/components/themed/RiverLoading.tsx");
